export default 'icon--arrow-right';